<template>
  <div class="app-content-back">
    <SearchContainer
      :add-tag-to-query="true"
      :auto-redirect="true"
      :selected-youth="selectedYouth"
      @selectedYouth="youthChanged"
    />
  </div>
</template>

<script>
import SearchContainer from './SearchContainer'
export default {
    name: 'ExercisesView',
    components: { SearchContainer },
    data () {
        return {
            selectedYouth: this.$route.params.key || 'F'
        }
    },
    mounted () {

    },
    methods: {
        youthChanged (selectedYouth) {
            this.selectedYouth = selectedYouth
        }
    }
}
</script>

<style scoped>

</style>